import type { CardColor } from "../schemas"

export type FactionPalette = {
  base: string
  muted: string
  faint: string
  textOn: string // readable text drawn on the faction color
}

export const FACTION_PALETTE: Record<CardColor, FactionPalette> = {
  colorless: {
    base: "rgb(var(--faction-colorless-rgb))",
    muted: "rgb(var(--faction-colorless-muted-rgb))",
    faint: "rgb(var(--faction-colorless-rgb) / 0.22)",
    textOn: "rgb(var(--faction-colorless-on-rgb))",
  },
  red: {
    base: "rgb(var(--faction-red-rgb))",
    muted: "rgb(var(--faction-red-muted-rgb))",
    faint: "rgb(var(--faction-red-rgb) / 0.22)",
    textOn: "rgb(var(--faction-red-on-rgb))",
  },
  yellow: {
    base: "rgb(var(--faction-yellow-rgb))",
    muted: "rgb(var(--faction-yellow-muted-rgb))",
    faint: "rgb(var(--faction-yellow-rgb) / 0.22)",
    textOn: "rgb(var(--faction-yellow-on-rgb))",
  },
  green: {
    base: "rgb(var(--faction-green-rgb))",
    muted: "rgb(var(--faction-green-muted-rgb))",
    faint: "rgb(var(--faction-green-rgb) / 0.22)",
    textOn: "rgb(var(--faction-green-on-rgb))",
  },
  blue: {
    base: "rgb(var(--faction-blue-rgb))",
    muted: "rgb(var(--faction-blue-muted-rgb))",
    faint: "rgb(var(--faction-blue-rgb) / 0.22)",
    textOn: "rgb(var(--faction-blue-on-rgb))",
  },
  purple: {
    base: "rgb(var(--faction-purple-rgb))",
    muted: "rgb(var(--faction-purple-muted-rgb))",
    faint: "rgb(var(--faction-purple-rgb) / 0.22)",
    textOn: "rgb(var(--faction-purple-on-rgb))",
  },
}

export const FACTION_NAMES: Record<CardColor, string> = {
  colorless: "Colorless",
  red: "Fury",
  yellow: "Command",
  green: "Thrive",
  blue: "Signal",
  purple: "Shadow",
}

/** Inline CSS custom properties for a card given its faction colors. */
export function cardCssVars(
  primary: CardColor,
  secondary?: CardColor,
): Record<string, string> {
  const p = FACTION_PALETTE[primary]
  const s = secondary ? FACTION_PALETTE[secondary] : undefined
  const border = s ? `linear-gradient(135deg, ${p.base}, ${s.base})` : p.base
  return {
    "--cf-primary": p.base,
    "--cf-primary-muted": p.muted,
    "--cf-primary-faint": p.faint,
    "--cf-primary-rgb": `var(--faction-${primary}-rgb)`,
    "--cf-secondary": s?.base ?? p.base,
    "--cf-secondary-faint": s?.faint ?? p.faint,
    "--cf-secondary-rgb": secondary
      ? `var(--faction-${secondary}-rgb)`
      : `var(--faction-${primary}-rgb)`,
    "--cf-text-on": p.textOn,
    "--cf-border": border,
  }
}
